import { ManagerUpdate } from "../types/manager.definition";
import {
  getManagerAvailabilities,
  getManagerById,
  updateManager,
} from "../webclients/manager.client";

export const managerApi = {
  getManagerById: async (managerId: string) => {
    const response = await getManagerById(managerId);
    return response.data;
  },
  updateManager: async (managerId: string, data: Partial<ManagerUpdate>) => {
    const response = await updateManager(managerId, data);
    return response.data;
  },
  getManagerAvailabilities: async (managerId: string) => {
    const response = await getManagerAvailabilities(managerId);
    return response.data;
  },
};

export default managerApi;
